var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B0D",
    d: "M50 100c27.615 0 50-22.385 50-50S77.615 0 50 0 0 22.385 0 50s22.385 50 50 50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M31.897 72.82a5.286 5.286 0 0 0 4.003-1.85l36.114-41.82c-1.015-1.584-2.718-2.51-4.48-2.51a5.521 5.521 0 0 0-4.003 1.763l-36.324 41.73c.956 1.673 2.718 2.689 4.69 2.689Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.897 72.82c.836 0 1.673-.179 2.42-.567v-34.98L62.425 70.97c1.016 1.224 2.51 1.852 4.123 1.852h1.135A5.31 5.31 0 0 0 73 67.504V31.956c-.18-2.987-2.51-5.317-5.407-5.317a5.24 5.24 0 0 0-2.42.568v35.01L37.006 28.49c-1.016-1.224-2.51-1.852-4.122-1.852h-1.016c-2.987 0-5.317 2.33-5.317 5.317v35.667c0 2.868 2.36 5.198 5.347 5.198Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 28.106,
    x2: 71.233,
    y1: 71.3,
    y2: 28.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.e21535250891943281ce97b5b033b356.svg";
export { ForwardRef as ReactComponent };